import { gql } from '@apollo/client';

export const BANK_PARSER_RULE_LIST = gql`
  query BankParserRuleList {
    BankParserRuleList {
      success
      total
      data {
        bankId
        bankPrefix
        bankCode
        bankNameEN
        bankNameTH
        bankImage
        ruleId
        bankExtractor
        receiveExtractor
        accountRegex
        accountFormatSample
        amountRegex
        dateRegex
        sampleText
        priority
        status
        hasCustomRule
      }
    }
  }
`;

export const INBOUND_AGENT_LIST = gql`
  query InboundAgentList {
    InboundAgentList {
      success
      data {
        id
        agentPrefix
        agentDesc
      }
    }
  }
`;

export const PAYMENT_INBOUND_MESSAGE_LIST = gql`
  query PaymentInboundMessageList($value: PaymentInboundMessageListInput) {
    PaymentInboundMessageList(value: $value) {
      success
      total
      page
      limit
      totalPages
      data {
        id
        b2cId
        agentPrefix
        cmsBankId
        tokenPrefix
        messageId
        dedupeKey
        rawText
        sender
        receivedAt
        status
        amount
        senderLast4
        receivingAccount
        bankCode
        transferAt
        matchedTransactionId
        meta
        createdAt
        updatedAt
        cmsBank {
          id
          b2cBank {
            id
            accountNumber
            accountName
            bank {
              id
              bankPrefix
              bankNameTH
              bankNameEN
              bankImage
            }
          }
        }
        matchedTransaction {
          id
          transactionId
          amount
          status
          createdAt
          user {
            id
            username
            phone
          }
          playerBank {
            id
            bankNumber
            firstName
            lastName
            bankPrefix
            bankNameTH
            bankNameEN
            bankImage
          }
        }
      }
    }
  }
`;

export const TEST_BANK_PARSER_REGEX = gql`
  query TestBankParserRegex($value: TestBankParserRegexInput!) {
    TestBankParserRegex(value: $value) {
      success
      data {
        rawText
        sender
        bankCode
        senderBank
        receivingBank
        receivingAccount
        amount
        senderLast4
        transferAt
        isBankDetected
        isAmountExtracted
        isAccountExtracted
        isReceiveDetected
        matchedRulePrefix
      }
    }
  }
`;
